import {defineMessages} from 'react-intl';

export const BreadcrumbsMessages = defineMessages({
  home: {
    id: 'Breadcrumbs.home',
    defaultMessage: 'Home',
    description: 'Link to home page',
  },
});
